import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const defaultAdCampaign: FaireAdCampaignEntity = {
  token: "default",
  type: "adCampaign",
  advertiserProfileToken: "default",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 0,
  segmentMetrics: {},
  performancePeriodTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
